export enum PasswordActionType {
    SEND_FORGOT_PASSWORD = '@@password/SEND_FORGOT_PASSWORD',
    CHANGE_PASSWORD_LOGGED_IN = '@@password/CHANGE_PASSWORD_LOGGED_IN',
    CHANGE_EXPIRED_PASSWORD = '@@password/CHANGE_EXPIRED_PASSWORD',
    CHANGE_FORGOT_PASSWORD = '@@password/CHANGE_FORGOT_PASSWORD',
    SET_CHANGE_PASSWORD_ERROR = '@@password/SET_CHANGE_PASSWORD_ERROR',
    VALIDATE_RESET_TOKEN = '@@password/VALIDATE_RESET_TOKEN',
}